// extracted by mini-css-extract-plugin
module.exports = {"shipping":"shipping_shipping__18lS5","content":"shipping_content__3Gfgm","image":"shipping_image__2aBLE","text":"shipping_text__6qppD"};